import React, { useContext } from "react";
import { Navbar as BSNavbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { UserContext } from "../../../contexts/UserContext";
import { colors, navbar as navbarTheme } from "../../../styles/theme";
// import LoginModal from "../../Login/LoginModal"; // adjust the path to where your LoginModal is
import AuthModal from "../../AuthModal"; // adjust the path to where your LoginModal is


const Navbar = () => {
  const { user, logout } = useContext(UserContext);
  const location = useLocation();

  // const getBrandText = () => {
  //   const path = "/" + location.pathname.split("/")[1];
  //   return routeNames[path] || "Dashboard";
  // };

  // Helper to get name by current pathname
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const getBrandText = (pathname) => {
    if (!pathname || pathname === "/" ) return "Home";

    const firstPath = pathname.split("/")[1] || "";
    
    const specialCases = {
      faq: "FAQ",
      // add more exceptions here
    };

  return specialCases[firstPath] || capitalize(firstPath);

    return capitalize(firstPath);
  };

  return (
    <BSNavbar
      bg="light"
      expand="lg"
      style={{
        marginLeft: 0,
        height: navbarTheme.height,
        boxShadow: colors.shadow,
      }}
    >
      <Container fluid>
        <BSNavbar.Brand
         style={{
            fontSize: navbarTheme.brand.fontSize,
            fontWeight: navbarTheme.brand.fontWeight,
          }}
        >
          {getBrandText(location.pathname)}
        </BSNavbar.Brand>
        
        {/* <Nav className="ms-auto">
          <NavDropdown title={user?.username || "User"} 
                              id="user-dropdown" 
                              align="end"
                              style={{
                                fontSize: navbarTheme.userDropdown.fontSize,
                                fontWeight: navbarTheme.userDropdown.fontWeight,
                              }}
          >
          <NavDropdown.Item as={Link} to="/profile">Profile</NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
          </NavDropdown>
        </Nav> */}
        {/* Right Side */}
        <Nav className="ms-auto">
          {user ? (
            // ✅ Logged In View
            <NavDropdown
              title={user.username}
              id="user-dropdown"
              align="end"
              style={{
                fontSize: navbarTheme.userDropdown.fontSize,
                fontWeight: navbarTheme.userDropdown.fontWeight,
              }}
            >
                <NavDropdown.Item as={Link} to="/profile">
                  Profile
                </NavDropdown.Item>

                <NavDropdown.Divider />

                <NavDropdown.Item onClick={logout}>
                  Logout
                </NavDropdown.Item>
            </NavDropdown>
            ) : (
            // ✅ Logged Out View
            <AuthModal defaultMode="login" />
            )}
        </Nav>
      </Container>
    </BSNavbar>
  );
};

export default Navbar;
